import React from 'react';

import PaymentStatusBadge from '~direct-debits/components/payment-batches/PaymentStatusBadge';
import { PaymentBatchClient } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatchClient;
}

// Adapter cell — the level-2 clients-in-batch table reads a row's
// `payment_status` field, but the shared badge component reads `row.status`.
// This thin wrapper keeps the badge contract stable and the column definition
// declarative.
const BatchClientPaymentStatusCell: React.FC<ComponentProps> = ({ row }) => (
  <PaymentStatusBadge status={row.payment_status} />
);

export default BatchClientPaymentStatusCell;
